import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { DashboardLayout } from "@/components/DashboardLayout";
import { LoadingBlock, EmptyState } from "@/components/common";
import { StatusBadge } from "@/components/StatusBadge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { euro, formatDate, BOOKING_STATUS_LABELS, PAYMENT_STATUS_LABELS } from "@/lib/format";

export default function GestionePrenotazioni() {
  const { data, isLoading } = useQuery({ queryKey: ["admin-bookings"], queryFn: async () => (await api.get("/admin/bookings")).data });
  const bookings = data?.bookings || [];
  return (
    <DashboardLayout title="Gestione prenotazioni">
      {isLoading ? <LoadingBlock /> : bookings.length === 0 ? <EmptyState title="Nessuna prenotazione" /> : (
        <div className="overflow-x-auto bg-white rounded-2xl border border-[#D2E3DB]">
          <Table>
            <TableHeader><TableRow><TableHead>Servizio</TableHead><TableHead>Paziente</TableHead><TableHead>Professionista</TableHead><TableHead>Data</TableHead><TableHead>Prezzo</TableHead><TableHead>Pagamento</TableHead><TableHead>Stato</TableHead></TableRow></TableHeader>
            <TableBody>
              {bookings.map((b) => (
                <TableRow key={b.id} data-testid={`admin-booking-${b.id}`}>
                  <TableCell className="font-semibold text-[#102A2A]">{b.service_name}</TableCell>
                  <TableCell className="text-[#5C6B68]">{b.patient_name}</TableCell>
                  <TableCell className="text-[#5C6B68]">{b.professional_name}</TableCell>
                  <TableCell className="text-[#5C6B68]">{formatDate(b.scheduled_date)}</TableCell>
                  <TableCell className="font-semibold text-[#087A73]">{euro(b.price_cents)}</TableCell>
                  <TableCell><StatusBadge status={b.payment_status} label={PAYMENT_STATUS_LABELS[b.payment_status]} /></TableCell>
                  <TableCell><StatusBadge status={b.booking_status} label={BOOKING_STATUS_LABELS[b.booking_status]} /></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </DashboardLayout>
  );
}
